interface FormErrorLabelProps {
  label: string | undefined
}

export const FormErrorLabel = ({ label }: FormErrorLabelProps) =>
  label ? <div className="d-block invalid-feedback">{label}</div> : <></>
